export default __webpack_public_path__ + "static/media/catherine-gagne.56bd5376.jpg";